import React from 'react';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import TabNav from '@/components/slide-menu/tab-nav';
import Container from '@/components/container';

export default function AutoMaterials(props: any) {
  return (
    <ContextProviderMenus.Provider value={{ children: props.children }}>
      <Container margin={false}>
        <TabNav alignCenter />
        {props.children}
      </Container>
    </ContextProviderMenus.Provider>
  );
}
